import React  from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { withFirebase } from '../Firebase';
import { Campaigns } from './Campaigns'
import { ExportCSV } from './ExportCSV'
import Moment from 'moment';
import { DateRange } from 'react-date-range';
import { Box, Grid } from '@theme-ui/components'
import { AuthUserContext, withAuthorization } from '../Session';
import 'react-tabs/style/react-tabs.css';

const HomePage = () => (
  <AuthUserContext.Consumer>
    {authUser => (
      <Box sx={{ margin: 20 }}>
        <h1>Campaing Dashboard</h1>
        <h2>Account email: {authUser.email}</h2>
        <ValueCampaignForm authUser={authUser} />
      </Box>
    )}
  </AuthUserContext.Consumer>
);

class ValueCampaignFormBase extends React.Component {
  constructor(props) {
    super(props);

    this.unsub = null
    this.companyUnsub = null
    var date = new Date(Date.now());
    date.setDate(date.getDate() - 365);
    this.state = {
        company: null,
        loading: false,
        campaigns: [],
        campaignsForExport: [],
        startDate: date,
        endDate: new Date(Date.now()),
    };

    this.handleDateSelect = this.handleDateSelect.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.companyUnsub = this.props.firebase.company(this.props.authUser.uid).onSnapshot(docSnapshot => {
                          console.log(`Received doc snapshot: ${docSnapshot}`);
                          Moment().locale(docSnapshot.data().country);
                          this.setState({
                            company: docSnapshot.data()
                          });
                        }, err => {
                          console.log(`Encountered error: ${err}`);
                        });

    this.unsub = this.fetchCampaigns();
  }

  fetchCampaigns(){
      const { startDate, endDate } = this.state;
      console.log(`New scan  fetching ${startDate} -  ${endDate}`);
      return this.props.firebase.campaigns(this.props.authUser.uid)
                              .where('time', ">=", startDate)
                              .where('time', "<=", endDate)
                              .onSnapshot(snapshot => {
            
            if (snapshot.empty) {
                console.log('No matching documents.');
                //return;
            }

            const campaignsList = [];
            const campaignsListForExport = [];
            var index = 0;
            snapshot.forEach(doc => {
                const { 
                  campaignType, 
                  activeInLastValue, 
                  inactiveInLastValue, 
                  spentLessThanValue, 
                  spentMoreThanValue, 
                  visitedLessThanValue, 
                  visitedMoreThanValue, 
                  city, 
                  storeId, 
                  offerValue, 
                  numberOfUserToTarget,
                  image,
                  likes,
                  dislikes,
                  time
                } = doc.data();
                index = index + 1;
                campaignsList.push({
                    name:Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM'),
                    index:index,
                    id: doc.id,
                    campaignType, 
                    activeInLastValue, 
                    inactiveInLastValue, 
                    spentLessThanValue, 
                    spentMoreThanValue, 
                    visitedLessThanValue, 
                    visitedMoreThanValue, 
                    city, 
                    storeId, 
                    offerValue, 
                    numberOfUserToTarget,
                    image,
                    likes: typeof likes !== 'undefined' && likes !== null ? likes.join(',\n') : '',
                    dislikes:  typeof dislikes !== 'undefined' && dislikes !== null ? dislikes.join(',\n') : '',
                    date:Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                    time:Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                    timestamp:time.toDate().valueOf(),
                });
                campaignsListForExport.push({
                    campaignType, 
                    activeInLastValue, 
                    inactiveInLastValue, 
                    spentLessThanValue, 
                    spentMoreThanValue, 
                    visitedLessThanValue, 
                    visitedMoreThanValue, 
                    city, 
                    storeId, 
                    offerValue, 
                    numberOfUserToTarget,
                    image,
                    likes: typeof likes !== 'undefined' && likes !== null ? likes.join(',\n') : '',
                    dislikes: typeof dislikes !== 'undefined' && dislikes !== null ? dislikes.join(',\n') : '',
                    date:Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                    time:Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                    timestamp:time.toDate().valueOf(),
                });
              })

              this.setState({
                campaigns: campaignsList,
                campaignsForExport: campaignsListForExport,
                loading: false,
              });
        }, err => {
            console.log(`Encountered error: ${err}`);
        }
  );
  }

  componentWillUnmount() {
    if(this.unsub !== null) this.unsub()
    if(this.companyUnsub !== null) this.companyUnsub()
  }

  handleDateSelect(event) {
    console.log(`New range selected ${event.startDate} -  ${event.endDate}`);
    if(event.startDate == event.endDate){
      return;
    }
    this.setState({
        startDate: new Date(event.startDate),
        endDate: new Date(event.endDate),
    }, () => {
        this.unsub = this.fetchCampaigns();
    })
  }


  render() {
    const { company, campaigns, loading, campaignsForExport, startDate, endDate } = this.state;

    return (
      <div>

        {loading && <div>Loading ...</div>}
        <h2>Company: {company != null ? company.name : ''} </h2><br/>
        <div>
          <Tabs>
            <TabList>
              <Tab>Campaings</Tab>
            </TabList>
            <TabPanel>
          <p>{Moment.tz(startDate, 'Europe/Belgrade').format('DD.MM.YYYY')} - {Moment.tz(endDate, 'Europe/Belgrade').format('DD.MM.YYYY')}</p>
          <DateRange
                    months={2}
                    moveRangeOnFirstSelection={true}
                    onChange={this.handleDateSelect}
                />
            <Grid 
              columns={[ 1, null, 1 ]}>
            Campaigns {campaigns.length}:
            </Grid>
            <div className="col-md-4 center">
                <ExportCSV csvData={campaignsForExport} fileName={company != null ? company.name : 'EmptyFile'} />
            </div>
            <Campaigns campaigns={campaigns}/>
            </TabPanel>
          </Tabs>
        </div>
      </div>
    );
  }
}

const ValueCampaignForm = withFirebase(ValueCampaignFormBase);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(HomePage);